import { render, staticRenderFns } from "./AdminBannerLayout.vue?vue&type=template&id=92846e54&scoped=true&"
import script from "./AdminBannerLayout.vue?vue&type=script&lang=js&"
export * from "./AdminBannerLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminBannerLayout.vue?vue&type=style&index=0&id=92846e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92846e54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBanner,VBtn,VCol,VDivider,VRow,VSheet})
